export const DROPPABLE_QUIZ_MODULE_EXPERIMENT_NAME = 'pen-4558_v2'
